var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "row roomy align-stretch margin-top-md margin-bottom-2xl" },
    [
      _c(
        "div",
        {
          staticClass: "column-12 laptop:column-4",
          staticStyle: { height: "100%" },
        },
        [
          _c(
            "a",
            {
              staticClass: "card blue",
              attrs: {
                href: "https://fontawesome.com/leaderboard/new#request",
              },
              on: {
                click: function ($event) {
                  return _vm.$posthog.capture(
                    "icon_requests_leaderboard_link_click"
                  )
                },
              },
            },
            [
              _c("div", { staticClass: "header" }, [
                _vm.version !== 5
                  ? _c("i", {
                      staticClass: "fas fa-message-question fa-fw fa-4x",
                    })
                  : _c("i", {
                      staticClass: "fas fa-question-circle fa-fw fa-4x",
                    }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "section" }, [
                _c("h2", { staticClass: "h4" }, [_vm._v("Request an Icon")]),
                _vm._v(" "),
                _c(
                  "p",
                  [
                    _vm._v(
                      "\n          Suggest an icon idea to our community on the\n          "
                    ),
                    _c(
                      "site-link",
                      {
                        attrs: { to: { name: "leaderboard.new" } },
                        nativeOn: {
                          click: function ($event) {
                            return _vm.$posthog.capture(
                              "icon_requests_leaderboard_link_click"
                            )
                          },
                        },
                      },
                      [_vm._v("Icon Requests Leaderboard")]
                    ),
                    _vm._v(".\n        "),
                  ],
                  1
                ),
              ]),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "column-12 laptop:column-4",
          staticStyle: { height: "100%" },
        },
        [
          _c(
            "site-link",
            {
              staticClass: "card teal",
              attrs: { to: _vm.$docs("/web/add-icons/upload-icons") },
              nativeOn: {
                click: function ($event) {
                  return _vm.$posthog.capture("docs_upload_icons_link_click")
                },
              },
            },
            [
              _c("div", { staticClass: "header" }, [
                _vm.version !== 5
                  ? _c("i", {
                      staticClass: "fas fa-cloud-arrow-up fa-fw fa-4x",
                    })
                  : _c("i", {
                      staticClass: "fas fa-cloud-upload-alt fa-fw fa-4x",
                    }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "section" }, [
                _c("h2", { staticClass: "h4" }, [_vm._v("Upload an Icon")]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "Upload your own icon to a Kit and easily use it just like it an official Font Awesome icon!"
                  ),
                ]),
              ]),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "column-12 laptop:column-4",
          staticStyle: { height: "100%" },
        },
        [
          _c(
            "site-link",
            {
              staticClass: "card yellow",
              attrs: { to: _vm.$docs("/web/add-icons/icon-wizard") },
              nativeOn: {
                click: function ($event) {
                  return _vm.$posthog.capture("icons_wizard_link_click")
                },
              },
            },
            [
              _c(
                "div",
                { staticClass: "header" },
                [
                  _c("font-awesome-icon", {
                    attrs: {
                      icon: _vm.$v6.solid.faSquareDashedCirclePlus,
                      "fixed-width": "",
                      size: "4x",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "section" }, [
                _c("h2", { staticClass: "h4" }, [
                  _vm._v("Use the Icon Wizard"),
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "You can magically add a modifier to any icon with our Icon Wizard. Give it a try!"
                  ),
                ]),
              ]),
            ]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }